import { PropsWithChildren } from 'react';

export const ModalContentSection = ({ children, header }: { header: string } & PropsWithChildren) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-l-sb text-base-5">{header}</div>
      {children}
    </div>
  );
};
